<script>
  const types = { news: 'Новости', blog: 'Блог', video: 'Видео' };
  export let type = 'news';
</script>

<span data-type={type}>{types[type]}</span>

<style lang="scss">
  span {
    padding: 4px 16px;
    font-weight: bold;
    font-size: 14px;
    font-family: Vela Sans;
    line-height: 140%;
    border-radius: 100px;

    &[data-type='blog'] {
      color: #fff;
      background: #ec0436;
    }

    &[data-type='news'] {
      color: #2c333c;
      background: #22eaac;
    }

    &[data-type='video'] {
      color: #fff;
      background: #041bec;
    }
  }
</style>
